import React, {Component} from 'react';
import {
    Button,
    Form,
    Alert
} from 'reactstrap';
import PropTypes from 'prop-types';
import FormWrapper from "../../commonComponents/formWrapper/FormWrapper.container";
import ConfirmPassword from "../confirmPassword/ConfirmPasswordActivation.container";
import './ResetPassword.css';
import {Redirect} from "react-router-dom";
import _ from 'lodash';
import { Utils } from './../../../utils/utils';
import { sharedLabelsPath } from "../../../reducers/common/localization";

class ResetPassword extends Component {
    constructor(props) {
        super(props);

        this.state = {
            password: '',
            passwordConfirm: ''
        };
    }

    componentWillMount() {
        this.props.onCheckToken(this.props.token);
    }

    render() {        
        return (
            <div className="reset-password-container">
                {this.renderContent()}
            </div>
        );
    }

    renderContent() {
        if (this.props.loading) {
            return <h6 className="text-center">{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>;
        }
        if (this.props.success) {
            return <Redirect to="/login"/>;
        }
        if (!this.props.token) {
            return <Alert color="danger">{_.get(this.props.translation, 'reset_password.incorrect_link_alert')}</Alert>;
        }
        if (!this.props.isActualToken) {
            return <Alert color="danger">{_.get(this.props.translation, 'reset_password.expired_link_alert')}</Alert>;
        }

        return (
            <div className="reset-password-form">
                <FormWrapper successMessage={_.get(this.props.translation, 'reset_password.success_message')}>
                    <Form onSubmit={this.handleSubmit}>
                        <h4 className="page-label">{_.get(this.props.translation, 'reset_password.label')}</h4>
                        <ConfirmPassword
                            password={this.state.password}
                            passwordConfirm={this.state.passwordConfirm}
                            handleChange={this.handleChange}
                        />
                        <div className="reset-password-submit">
                        <Button className="reset-password-submit-button olive-green-btn" type="submit">{_.get(this.props.translation, 'reset_password.submit_button')}</Button>
                        </div>
                    </Form>
                </FormWrapper>
            </div>
        );
    }

    handleChange = (fieldName) => (e) => {
        this.setState({[fieldName]: e.target.value});
    };

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.state.password !== '' && this.state.password === this.state.passwordConfirm && Utils.isValidPassword(this.state.password)){
            this.props.onResetPassword(this.props.token, { newPassword: this.state.password });
        }
    };
}

ResetPassword.propTypes = {
    isActualToken: PropTypes.bool,
    loading: PropTypes.bool,
    token: PropTypes.string,
    onResetPassword: PropTypes.func,
    translation: PropTypes.object.isRequired,
    onCheckToken: PropTypes.func.isRequired
};

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/components/accountManagement/resetPassword/ResetPassword.js